import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setPreviousRoute } from '../redux/slices/previousRouteSlice';

const RouteChangeListener = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location.pathname.startsWith('/search-result')) {
      dispatch(
        setPreviousRoute(location.pathname + location.search)
      );
    }
  }, [location, dispatch]);

  return null;
};

export default RouteChangeListener;
